module.exports = __webpack_public_path__ + "static/media/people.d4b5ffb9.PNG";